import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Button, Typography, Card, message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography

const PasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const PasswordForm = () => {
const navigate=useNavigate()
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "#f5f5f5" }}>
      <Card style={{ width: 400, textAlign: "center", padding: 20 }}>
        <Title level={3}>Set Your Password</Title>
        <Formik
          initialValues={{ password: "", confirmPassword: "" }}
          validationSchema={PasswordValidationSchema}
          onSubmit={(values) => {
            console.log("Password Set:", values);
            values.type="email";
            values.email_or_phone=localStorage.getItem("verification_email");
            values.reset_token=localStorage.getItem("verification_otp");
            values.confirm_password=values.confirmPassword;
            axios.put(`${process.env.REACT_APP_BACKEND_URI}/auth/reset-password`,values)
            .then((response)=>{
                message.success("Password Changed Successully");
                localStorage.clear();
                navigate("/login");

            }).catch((error)=>{
                message.error("Something went Wrong");
            })
          }}
        >
          {({ errors, touched }) => (
            <Form style={{ marginTop: 20 }}>
              <Field
                name="password"
                as={Input.Password}
                placeholder="Enter Password"
                style={{ marginBottom: 10 }}
              />
              {errors.password && touched.password && (
                <Text type="danger">{errors.password}</Text>
              )}

              <Field
                name="confirmPassword"
                as={Input.Password}
                placeholder="Confirm Password"
                style={{ marginTop: 10 }}
              />
              {errors.confirmPassword && touched.confirmPassword && (
                <Text type="danger">{errors.confirmPassword}</Text>
              )}

              <Button type="primary" htmlType="submit" block style={{ marginTop: 20 }}>
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </div>
  );
};

export default PasswordForm;
